<div class="dialog-header">
  <h3 mat-dialog-title>{{ "vehicle-status.title" | translate }}</h3>
</div>

<mat-dialog-content>
  <form [formGroup]="statusForm">
    <div class="current-status" *ngIf="currentStatus !== null">
      <span class="current-status-label">
        {{ "vehicle-status.current-status" | translate }}
      </span>
      <span
        class="status-badge"
        [ngClass]="{ active: currentStatus, inactive: !currentStatus }"
      >
        {{
          (currentStatus ? "vehicle-status.active" : "vehicle-status.inactive")
            | translate
        }}
      </span>
    </div>

    <mat-form-field class="full-width">
      <mat-label>{{ "vehicle-status.new-status" | translate }}</mat-label>
      <mat-select formControlName="active">
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">
          {{ option.label | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="statusForm.get('active')?.hasError('required')">
        {{ "vehicle-status.required-status" | translate }}
      </mat-error>
    </mat-form-field>

    <div class="warning-box">
      <mat-icon
        class="warning-icon"
        fontIcon="bosch-ic-alert-warning-filled"
      ></mat-icon>
      <span class="warning-text">
        {{ "vehicle-status.warning-message" | translate }}
      </span>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog(false)">
    {{ "button-close" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)"
    [disabled]="statusForm.invalid"
  >
    {{ "button-save" | translate }}
  </button>
</mat-dialog-actions>
